import { useMutation } from '@tanstack/react-query';
import { update, updateBulk } from '../requests/processData';

const KEY = 'processData';

const useUpdateProcessData = () => useMutation({
  mutationKey: [KEY, 'update'],
  mutationFn: (data) => update(data),
});

const useUpdateProcessDataBulk = () => useMutation({
  mutationKey: [KEY, 'updateComponentBulk'],
  mutationFn: (data) => updateBulk(data),
});

const processDataMutations = {
  useUpdateProcessData,
  useUpdateProcessDataBulk,
};

export default processDataMutations;
